/**
 * Whether a window `message` event came from a kizen-controlled origin and may
 * be trusted for cross-frame messaging (e.g. the AI chat embed, the plugin
 * frame proxy). Anything that can't be parsed as a URL is untrusted.
 */
export const isTrustedKizenMessageOrigin = (origin: string): boolean => {
  let hostName = '';
  try {
    hostName = new URL(origin).hostname;
  } catch {
    return false;
  }
  return /^.*\.kizen\.(com|dev)$/.test(hostName);
};
